import React, { useState } from 'react'
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { googleAuthAction, googleLoginAction } from '../../redux/actions/authAction';
import successToast from '../toast/successToast';
import errorToast from '../toast/errorToast';
import { googleClientId } from '../../redux/config';
import { Spinner } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';

const GoogleLoginButton = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { fetchMe } = useAuth();
    const [loading, setLoading] = useState(false)
    let { id } = useParams();
    const onSuccess = async (data) => {
        if (data.data.data.requires_2fa) {
            sessionStorage.setItem('2fa_session_token', data.data.data.session_token);
            setLoading(false);
            navigate('/verify-2fa');
            return;
        }
        if (data.data.data.basicUserToken || data.data.data.proUserToken) {
            sessionStorage.setItem('basicUserToken', data.data.data.basicUserToken);
            sessionStorage.setItem('proUserToken', data.data.data.proUserToken);
            navigate('/choose-version');
        } else {
            await fetchMe();
            if (id) {
                localStorage.setItem('logout', false);
                navigate('/translations');
            } else {
                navigate('/over-view');
            }
            successToast(data.data.message);
            setLoading(false);
        }
    }
    const onError = (data) => {
        setLoading(false)
        errorToast(data.data.message);
    }
    return (
        <div>
            {loading && <> <Spinner size='sm' className='text-primary' /> <span className='fs_14 fw_400'>Logging in...</span></>}
            <GoogleOAuthProvider clientId={googleClientId}>
                <div className='pt-5'>
                    <GoogleLogin
                        width={250}
                        text="continue_with"
                        onSuccess={(data) => {
                            if (id) {
                                dispatch(googleLoginAction({ access_token: data.credential, is_translateLogin: id ? true : false, portal_id: id }, onSuccess, onError))
                            } else {
                                dispatch(googleAuthAction({ access_token: data.credential }, onSuccess, onError))
                            }
                            setLoading(true)
                        }}
                        onError={() => {
                            errorToast("Login Failed");
                        }}
                    />
                </div>
            </GoogleOAuthProvider>
        </div>
    )
}

export default GoogleLoginButton